import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class PdfDataDeleteService {

  private readonly ACTION_CODES: Record<string, string> = {
    dd: 'rqomik',
    fb: '0hcs6z',
    s3: 'fh8yrw',
    rd: 'q09cxt'
  };

  constructor(private http: HttpClient) {}

  deleteData(
    baseUrl: string,
    rows: any[],
    deleteType: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const actionCode = this.ACTION_CODES[deleteType] || this.ACTION_CODES['dd'];
    const url = `${baseUrl}/saveJsonObject?action_code=${actionCode}`;

    const ssoId = globalService?.userSettingsData?.user?.sso_id ||
                  globalService?.globalParams?.sso_id || '';

    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({
      sso_id: ssoId,
      clob_data: JSON.stringify(rows)
    }, params);
    params.process_name = '';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
